export const setDoctorOptions = ({ columns, data }) => {
  const doctorAccessor = columns.findIndex((c) => c.accessor === 'doctor');

  data.forEach((d) => {
    const doctorIndex = columns[doctorAccessor].options.findIndex(
      (x) => x.id === d.id,
    );

    if (doctorIndex === -1)
      columns[doctorAccessor].options.push({
        id: d.id,
        value: d.id,
        label: `${d.lastName?.toUpperCase()} ${d.firstName} `,
        firstName: d.firstName,
        lastName: d.lastName,
        isActive: d.isActive,
        selected: true,
      });
  });

  columns[doctorAccessor].options = [
    columns[doctorAccessor].options[0],
    ...columns[doctorAccessor].options
      .slice(1)
      .toSorted((a, b) => a.label.localeCompare(b.label)),
  ];

  return columns;
};
